import { request } from './api.js';

/** 灯控列表请求参数 */
interface LightModuleListParams {
    page?: number;
    size?: number;
}

/** 灯控列表响应 */
interface LightModuleListResponse {
    code: number;
    data?: {
        rows?: any[];
    };
    message?: string;
}

/** 灯控新增/修改请求参数 */
export interface LightModuleParams {
    id?: number;
    type?: number;
    brand_id?: string | number;
    channel_count?: string | number;
    name?: string;
    ip?: string;
    port?: number;
}

/** 配置灯控线路请求参数 */
export interface ConfigLightModuleParams {
    light_control_id: number;
    channel_number_id: number;
    room_number_id: number;
    config?: {
        no: string;
    };
}

/** 切换灯状态请求参数 */
interface SwitchLightParams {
    light_control_id: number;
    channel_number_id: number;
    light_status: number;
    duration?: number | null;
}
interface UploadLanParams {
    light_control_id: number;
    response: string;
}

// 测试开关灯请求参数
interface TestSwitchLightParams {
    light_control_id?: number | string;
    channel_number_id?: number | string;
}

// 灯控设置
// 灯控列表
export const getLightModuleListApi = (data?: LightModuleListParams): Promise<LightModuleListResponse> => request(`/_hotel/light_control`, 'get', data);
// 灯控新增
export const addLightModuleApi = (data?: LightModuleParams): Promise<any> => request(`/_hotel/light_control`, 'post', data);
// 灯控修改
export const updateLightModuleApi = (data?: LightModuleParams): Promise<any> => request(`/_hotel/light_control/${data?.id}`, 'put', data);
// 灯控删除
export const deleteLightModuleApi = (data?: { id: number }): Promise<any> => request(`/_hotel/light_control/${data?.id}`, 'delete', data);
// 配置灯控线路与桌台的关联
export const configLightModuleApi = (data?: ConfigLightModuleParams): Promise<any> => request(`/_hotel/light_control/config_channel`, 'post', data);
// 切换灯状态
export const switchLightModuleApi = (data?: SwitchLightParams): Promise<any> => request(`/_hotel/light_control/toggle_light`, 'post', data);
//获取所有实际台桌列表及关联灯控（排除虚拟台）
export const getActualRoomListApi = (data?: { page?: number; pageSize?: number }): Promise<any> => request(`/_hotel/room-type/actual-rooms`, 'get', data);
// 灯控品牌列表
export const getLightModuleBrandListApi = (data?: any): Promise<any> => request(`/_hotel/light_control/brands`, 'get', data);

// 灯控已绑定IP列表
export const getLightModuleBindIpListApi = (): Promise<any> => request(`/_hotel/light_control/ip_list`, 'get');

// 更新局域网灯控状态
export const updateLightLanApi = (data: UploadLanParams): Promise<any> => request(`/_hotel/light_control/lan_status_callback`, 'post', data);

// 测试开灯
export const testTurnOnLightApi = (data?: TestSwitchLightParams): Promise<any> => request(`/_hotel/light_control/test_on`, 'post', data);
// 测试关灯
export const testTurnOffLightApi = (data?: TestSwitchLightParams): Promise<any> => request(`/_hotel/light_control/test_off`, 'post', data);
